export default __webpack_public_path__ + "static/media/telegram.6120793a.svg";